var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6762_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36364 15.4081H4.54545V7.77618L0 4.40918V14.0613C0 14.8065 0.611364 15.4081 1.36364 15.4081Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4546 15.4081H18.6364C19.391 15.4081 20 14.8042 20 14.0613V4.40918L15.4546 7.77618",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4546 1.93949V7.77563L20 4.40862V2.61289C20 0.947346 18.075 -0.0021494 16.7273 0.996728",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54541 7.77559V1.93945L9.99996 5.97986L15.4545 1.93945V7.77559L9.99996 11.816",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.61289V4.40862L4.54545 7.77563V1.93949L3.27273 0.996728C1.92273 -0.0021494 0 0.947346 0 2.61289Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6762_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14.8148,
    fill: "white",
    transform: "translate(0 0.592773)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGmail);
export default __webpack_public_path__ + "static/media/logo-gmail.0782cc4b7ee0a8b740cdd66558c5cd9b.svg";
export { ForwardRef as ReactComponent };